import { faCheckCircle, faChevronDown, faChevronUp, faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { Col, Collapse, Container, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { snakeToTitleCase } from "../../../../utils/string-utils";
import { Evidence, renderMatchDetails, VerificationState } from "../common/verification";
import PersonalIdentifier from "../../../common/PersonalIdentifier";
import { ScanMulti } from "./models";
import { LLMDashboardMarkdownRenderer } from "./LLMDashboardMarkdownRenderer";

export const EvidenceBlock = (props: {
    evidence: Evidence[],
    scanMulti?: ScanMulti,
}) => {

    const [showEvidenceIndex, setShowEvidenceIndex] = useState<number | null>(null);
    const [verificationState, setVerificationState] = useState<VerificationState>();

    return (
        <Row>
            <Col className="description-text">
                <Row>
                    <Col className="description-heading">
                        Evidence
                    </Col>
                </Row>
                {
                    props.evidence.map((evi: Evidence, index: number) => {
                        const verification = evi["verification"] as VerificationState | undefined;
                        return (
                            <Container>
                                <Row className="mt-2 description-section" 
                                    // onClick={() => {setShowEvidenceIndex((showEvidenceIndex === null || showEvidenceIndex !== index) ? index : null); setVerificationState(verification)}}
                                >
                                    <Col>
                                        <Row>
                                            <Col xs={12}>
                                                {
                                                    evi.source && (
                                                        <strong><LLMDashboardMarkdownRenderer content={snakeToTitleCase(evi.source)} scanMulti={props.scanMulti} /></strong>
                                                    )
                                                }
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                {
                                                    props.scanMulti ? (
                                                        <LLMDashboardMarkdownRenderer content={evi.details} scanMulti={props.scanMulti} />
                                                    ) : (
                                                        <>{evi.details}</>
                                                    )
                                                }
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                {
                                                    evi.date && (
                                                        <LLMDashboardMarkdownRenderer content={evi.date} scanMulti={props.scanMulti} />
                                                    )
                                                }
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>

                                {/* {verificationState && verificationState.matches.length > 0 && (
                                    <Collapse in={showEvidenceIndex === index}>
                                        <div>
                                            <hr className="my-2" />
                                            <Row>
                                                <Col>
                                                    <small className="text-muted">
                                                        <strong>Context Data:</strong>
                                                    </small>
                                                    {renderMatchDetails(verificationState)}
                                                </Col>
                                            </Row>
                                        </div>
                                    </Collapse>
                                )} */}
                            </Container>
                        );
                    })
                }
            </Col>
        </Row>
    )
};
